/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import GenericMenu from 'ui/components/main-menu/GenericMenu.vue';
import CriticalUpdates from 'ui/components/CriticalUpdates.vue';
import BadRequest from 'ui/components/request-handlers/BadRequest.vue';
import UploadLauncher from 'shared/ui/components/uploader/UploadLauncher.vue';
import MailLauncher from 'shared/ui/components/MailLauncher.vue';
import GlobalHotkeys from 'shared/ui/components/GlobalHotkeys.vue';

// Mixins
import { mixin as clickaway } from 'vue-clickaway';

/**
 * EventMenu component, used to display list of available package links.
 *
 * The menu organizes 3 types of links:
 *
 * 1. Category with a list of modules
 * 2. A single category that has multiple submodules (example: analytics)
 * 3. A module that declares its own component as submenu (example: marketplace)
 *
 * If a category contains one link only it directly open the page.
 *
 * By the time of writing, categories are listed and organaized in the `categories-map.json`.
 * TODO: check with package team if we have to move it in some package.
 *
 * @example
 * EventMenu(:modules="modules" :current="currentPage")
 *
 * @category ui.components.main-menu
 * @exports EventMenu
 * @component
 */
const __vue_script__ = {
    name: 'EventMenu',

    components: { CriticalUpdates, BadRequest, MailLauncher, UploadLauncher, GlobalHotkeys },

    extends: GenericMenu,

    mixins: [clickaway],

    props: {
        event: {
            type: Object,
            required: true
        },

        orgId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            eventId: this.event._id,
            activeCategory: {},
            categories: [],
            currentSubmenu: null,
            currentSubmenuProps: null,
            displayedCategory: {},
            enableHotkeys: false,
            hoverCategory: '',
            openSubmenu: false,
            updatablePackages: [],
        };
    },

    computed: {
        currentDocId() {
            const { originalPath, regexp } = this.current;
            if (!originalPath?.length || !regexp) {
                return;
            }

            const [modelKey] = originalPath
                .match(regexp)
                .filter(p => !p.includes('eventId'))
                .filter(p => p.endsWith('Id'))
                .reverse();

            if (!modelKey) {
                return;
            }

            const params = this.$router.getRouteParams();

            return params[modelKey.replace(':', '')];
        }
    },

    watch: {
        // This changes when the 'route:change:success' event is intercepted by `MainMenu`
        current() {
            console.info('[EventMenu] Current page changed from outside context', this.current);
            this.selectCurrentCategory();

            if (!this.parentMinified) {
                this.updateParent();
            }
        },

        // This changes when the 'route:update' event is intercepted by `MainMenu`
        currentSearchParams() {
            console.info('[EventMenu] Current search parameters changed', this.currentSearchParams);
            this.selectCurrentCategory();
        },

        // If main menu is open with a wrong value (external navigation), and the menu has a submenu
        // notify the main menu that it has to hide its labels.
        parentMinified(value) {
            if (!value && this.openSubmenu) {
                this.updateParent();
            }
        }

    },

    async created() {
        const categories = this.$services.menu.getAndInitializeCategories();

        const filteredModules = this.$services.user.filterByRoles(Object.values(this.modules));
        const filteredCategories = this.$services.user.filterByRoles(categories);

        this.categories = this.$services.menu.categorizeModules(filteredModules, filteredCategories);

        this.selectCurrentCategory();

        // Sets up initial main menu state
        if (!this.parentMinified) {
            this.updateParent();
        }

        // initialize bullets and packages to update counters for marketplace menu items
        await this.initMarketplace();

        // Check if the user can use hotkeys
        this.enableHotkeys = this.$services.user.isDeveloper() && this.$services.blueprint.isModuleInstalled('document-editor');

        // Adds the event as last accessed
        this.$services.event.setLastAccessed(this.$cookies, this.$services.storage, this.event._id);
    },

    mounted() {
        window.BSTG.hotkeys = this.$refs['hotkeys'];
        window.BSTG.hotkeys.bind('cmd + i, ctrl + i', this.openDocument.bind(this, false), 'Opens the current model in the document editor');
        window.BSTG.hotkeys.bind('cmd + shift + i, ctrl + shift + i', this.openDocument.bind(this, true), 'Opens the current model in a new window in the document editor');
    },

    methods: {
        /**
         * Marks the current category as selected.
         */
        selectCurrentCategory() {
            // Determines if category has links or a submenu, and open the current category.
            for (const category of this.categories) {
                const linksKeys = category.additional_types.concat('links', 'unordered_links');

                // Since the category links can be stored under different keys, we
                // cycle through them in order to find the current selected category
                // and contextually we count for items to check if we have to remove
                // it from the menu.
                for (const key of linksKeys) {
                    if (category[key].find(link => this.matchesRoute(link))) {
                        this.displayedCategory = category;
                        return this.openCategory(category, false);
                    }
                }
            }
        },

        /**
         * Navigates or expands the second menu level
         *
         * @param {Object} category the category to explore.
         * @param {Boolean} [navigate=true] should navigate to the first item in category?
         * @param {Object} [$event] Vue onClick event object
         */
        openCategory(category, navigate = true, $event) {
            if (!category.hasSubmenu && $event && ($event.metaKey || $event.ctrlKey)) {
                // CMD + click or CTRL + click opens in a new tab
                return;
            }

            this.activeCategory = category;
            this.openSubmenu = category.hasSubmenu || false;

            // Thanks to this check we don't expand the main menu at each page change.
            if (navigate) {
                this.updateParent();
            } else {
                this.restoreParent();
            }
        },

        /**
         * Sets the current submenu if the current category specifies one.
         *
         * This will load the component as defined in the menu store.
         */
        setCurrentSubmenu() {
            const category = this.categories.find(cat => cat.name === this.activeCategory.name);

            if (category.submenu) {
                const sub = (this.submenus || {})[category.submenu] || {};

                this.currentSubmenu = sub.component;
                this.currentSubmenuProps = sub.props;
            }
        },

        /**
         * When user clicks out from the menu this method is called.
         */
        handleClickaway() {
            if (this.activeCategory.name !== this.displayedCategory.name) {
                this.activeCategory = this.displayedCategory;
                this.openSubmenu = this.displayedCategory.hasSubmenu;

                this.updateParent();
            }
        },

        /**
         * Restored minified state of parent
         * Used when menu is minified with submenu opened
         * After click on menu item, submenu closes and minifies again
         */
        restoreParent() {
            this.$emit('submenu:selected');
        },

        /**
         * Updates the parent with submenu state changes
         */
        updateParent() {
            this.$emit('submenu:open', !!this.openSubmenu);
        },

        /**
         * Initializes marketplace bullets and counters
         */
        async initMarketplace() {
            try {
                const pkgsToUpdate = await this.$services.market.getAvailableUpdates(this.eventId);

                this.$services.menu.addMarketplaceBullets(this.categories, pkgsToUpdate.length);
                this.updatablePackages = pkgsToUpdate;
            } catch (err) {
                // expected: marketplace is not always available (localnodes)
                // also sometimes the marketplace calls to backend fail
            }
        },

        /**
         * Opens the external resource URL
         *
         * @param {String} url the url to open
         */
        openExternal(url) {
            return this.$services.router.openNewWindow(url);
        },

        /**
         * Returns label for given menu link
         *
         * @param {Object} link
         * @returns {String}
         */
        getLinkLabel(link) {
            if (link.bstgMenu) {
                return this.$utils.locales.localizeLabel(link.bstgMenu.title);
            }

            if (link.label) {
                return this.$t(link.label);
            }

            return link.title;
        },

        /**
         * Checks if the given category is visible or not
         *
         * @param {object} category the category to check
         *
         * @returns {boolean} whether the category is visible or not
         */
        isCategoryVisible(category) {
            if (category.visibility && !this[category.visibility]()) {
                return false;
            }
            return true;
        },

        /**
         * This method is used to determine if the legacy analytics
         * menu item should be visible or not.
         * We need to keep this function (even if returning false all the time) to be sure that
         * workspace that have the old analytics pkg installed do not display it anymore.
         * Once no running workspace have the pkg installed, this can be dropped
         * Can use this to check the usage:
         * @see https://grafana.spotme-shared-services.com/d/S4Jn1D0Vz/packages-usage?orgId=1&var-env=prod&var-backend_ds=backend-api-prod&var-pkgVersion=&var-pkgId=lib-analytics&from=now-24h&to=now
         *
         * @returns {boolean}
         */
        showLegacyAnalytics() {
            return false;
        },

        /**
         * Handler for opening a document in the document editor
         *
         * @param {boolean} newWindow open in new window
         */
        openDocument(newWindow) {
            const { controllers } = this.$services.blueprint.getModuleByName('document-editor');
            const route = controllers['document-editor'].route;

            const document = this.currentDocId;
            if (!document) {
                return;
            }

            if (newWindow) {
                console.info('[EventMenu] Opening document in a new window');
                const path = route.replace(':eventId', this.event._id);
                this.$services.router.openNewWindow(`${path}?document=${document}`);
            } else {
                console.info('[EventMenu] Opening document');
                this.$router.push(route, { eventId: this.event._id }, { document });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.handleClickaway,
          expression: "handleClickaway",
        },
      ],
      staticClass: "sidemenu",
    },
    [
      _vm._t("heading"),
      _c("div", { staticClass: "menus" }, [
        _c("div", { staticClass: "top-level-menu" }, [
          _c(
            "ul",
            _vm._l(_vm.categories, function (category) {
              return _c(
                "li",
                {
                  key: category.name,
                  class: {
                    selected: category.name === _vm.displayedCategory.name,
                    "has-sub": category.hasSubmenu,
                    active: category.name === _vm.activeCategory.name,
                    hidden: !_vm.isCategoryVisible(category),
                  },
                  on: {
                    mouseover: function ($event) {
                      _vm.hoverCategory = category.name
                    },
                    mouseleave: function ($event) {
                      _vm.hoverCategory = ""
                    },
                  },
                },
                [
                  _c(
                    "v-popover",
                    {
                      attrs: {
                        disabled: !(
                          _vm.hoverCategory == category.name &&
                          ((_vm.openSubmenu &&
                            category.name !== _vm.activeCategory.name) ||
                            _vm.parentMinified)
                        ),
                        open: true,
                        delay: { show: 100, hide: 100 },
                        placement: "auto",
                        "popover-class": "tooltip-comp menu-tooltip",
                      },
                    },
                    [
                      _c("template", { slot: "popover" }, [
                        _c("p", [_vm._v(_vm._s(_vm.$t(category.label)))]),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: !category.hasSubmenu
                          ? _vm.getLink(category)
                          : false,
                        "data-cue": category.name,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openCategory(
                            category,
                            category.hasSubmenu,
                            $event
                          )
                        },
                      },
                    },
                    [
                      category.counter && category.counter.count
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top",
                                  value: {
                                    content: _vm.$tc(
                                      category.counter.tooltip,
                                      category.counter.count
                                    ),
                                    boundariesElement: "body",
                                  },
                                  expression:
                                    "{content: $tc(category.counter.tooltip, category.counter.count), boundariesElement: 'body'}",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "counter",
                            },
                            [_vm._v(_vm._s(category.counter.count))]
                          )
                        : _vm._e(),
                      category.icon
                        ? _c("i", { class: category.icon }, [
                            category.bullet
                              ? _c("span", { staticClass: "bullet" })
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t(category.label))),
                      ]),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm.$services.user.hasPermission("org_realms.public_api", {
            org_id: _vm.orgId,
          })
            ? _c("ul", { staticClass: "externals" }, [
                _c(
                  "li",
                  {
                    on: {
                      mouseover: function ($event) {
                        _vm.hoverCategory = "api"
                      },
                      mouseleave: function ($event) {
                        _vm.hoverCategory = ""
                      },
                    },
                  },
                  [
                    _c(
                      "v-popover",
                      {
                        attrs: {
                          disabled: !(
                            _vm.hoverCategory == "api" &&
                            ((_vm.openSubmenu &&
                              "api" !== _vm.activeCategory.name) ||
                              _vm.parentMinified)
                          ),
                          open: true,
                          delay: { show: 100, hide: 100 },
                          placement: "auto",
                          "popover-class": "tooltip-comp menu-tooltip",
                        },
                      },
                      [
                        _c("template", { slot: "popover" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("main_menu.externals.event_api"))
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "a",
                      {
                        attrs: { "data-cue": "api-page" },
                        on: {
                          click: function ($event) {
                            _vm.openExternal(
                              _vm.$utils.url.getDeveloperDocURL({
                                eventId: _vm.eventId,
                              })
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "ic-box" }),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("main_menu.externals.event_api"))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._l(_vm.categories, function (category) {
        return category.hasSubmenu
          ? _c(
              "div",
              {
                key: category.name,
                staticClass: "submenu",
                class: [
                  category.name === _vm.activeCategory.name && _vm.openSubmenu
                    ? "in"
                    : "",
                ],
              },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t(category.label)))]),
                category.name === _vm.activeCategory.name && category.submenu
                  ? _c(_vm.currentSubmenu, {
                      tag: "component",
                      attrs: { params: _vm.currentSubmenuProps },
                    })
                  : _vm._e(),
                !category.submenu && category.links.length
                  ? _c(
                      "ul",
                      _vm._l(category.links, function (link) {
                        return _c(
                          "li",
                          {
                            class: [
                              _vm.matchesRoute(link) ? "selected" : "",
                              link.hideNavUnlessActive &&
                              !_vm.matchesRoute(link)
                                ? "hide"
                                : "",
                            ],
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getLink(link),
                                  "data-cue": link.name,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreParent()
                                  },
                                },
                              },
                              [
                                link.counter && link.counter.count
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content: _vm.$tc(
                                                link.counter.tooltip,
                                                link.counter.count
                                              ),
                                              boundariesElement: "body",
                                            },
                                            expression:
                                              "{content: $tc(link.counter.tooltip, link.counter.count), boundariesElement: 'body'}",
                                          },
                                        ],
                                        staticClass: "counter",
                                      },
                                      [_vm._v(_vm._s(link.counter.count))]
                                    )
                                  : _vm._e(),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$utils.strings.capitalize(
                                        _vm.getLinkLabel(link)
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._l(category.additional_types, function (add_type) {
                  return _c(
                    "ul",
                    _vm._l(category[add_type], function (link) {
                      return _c(
                        "li",
                        { class: [_vm.matchesRoute(link) ? "selected" : ""] },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.getLink(link),
                                "data-cue": link.name,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.restoreParent()
                                },
                              },
                            },
                            [
                              link.counter && link.counter.count
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: _vm.$tc(
                                              link.counter.tooltip,
                                              link.counter.count
                                            ),
                                            boundariesElement: "body",
                                          },
                                          expression:
                                            "{content: $tc(link.counter.tooltip, link.counter.count), boundariesElement: 'body'}",
                                        },
                                      ],
                                      staticClass: "counter",
                                    },
                                    [_vm._v(_vm._s(link.counter.count))]
                                  )
                                : _vm._e(),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$utils.strings.capitalize(
                                      _vm.getLinkLabel(link)
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                }),
                !category.submenu && category.unordered_links.length
                  ? _c(
                      "ul",
                      _vm._l(category.unordered_links, function (link) {
                        return _c(
                          "li",
                          {
                            class: [
                              _vm.matchesRoute(link) ? "selected" : "",
                              link.hideNavUnlessActive &&
                              !_vm.matchesRoute(link)
                                ? "hide"
                                : "",
                            ],
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getLink(link),
                                  "data-cue": link.name,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreParent()
                                  },
                                },
                              },
                              [
                                link.counter && link.counter.count
                                  ? _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: {
                                              content: _vm.$tc(
                                                link.counter.tooltip,
                                                link.counter.count
                                              ),
                                              boundariesElement: "body",
                                            },
                                            expression:
                                              "{content: $tc(link.counter.tooltip, link.counter.count), boundariesElement: 'body'}",
                                          },
                                        ],
                                        staticClass: "counter",
                                      },
                                      [_vm._v(_vm._s(link.counter.count))]
                                    )
                                  : _vm._e(),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$utils.strings.capitalize(
                                        _vm.getLinkLabel(link)
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e()
      }),
      _vm._t("baseline"),
      _vm.event.stage === "production"
        ? _c("critical-updates", {
            attrs: { updates: _vm.updatablePackages, event: _vm.event },
          })
        : _vm._e(),
      _c("bad-request"),
      _c("upload-launcher", { attrs: { event: _vm.event } }),
      _vm.$services.user.hasPermission("event_actions.send_email", {
        event_id: _vm.eventId,
      })
        ? _c("mail-launcher")
        : _vm._e(),
      _c("global-hotkeys", {
        ref: "hotkeys",
        attrs: { enabled: _vm.enableHotkeys },
      }),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/main-menu/EventMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__